import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import type { ExtractSpecificVerbRoutes, RouteSegment, HttpVerb } from '@openclassrooms/sdk';
import executeRequest from '../services/executeRequest';
import useInvalidateQueryKeys from './useInvalidateQueryKeys';
import type { ApiRoutes, GlobalRequestBuilder, RequestOption, MutateOptions } from '../types';
export default function useMutationRequest(verb, path, mutationOptions) {
  const $ = _c(22);
  const invalidateQueryKeys = useInvalidateQueryKeys();
  let t0;
  if ($[0] !== mutationOptions) {
    t0 = mutationOptions || {};
    $[0] = mutationOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let onError;
  let onSettled;
  let onSuccess;
  let otherMutationOptions;
  let t1;
  if ($[2] !== t0) {
    ({
      onSuccess,
      onError,
      onSettled,
      queryKeysToInvalidate: t1,
      ...otherMutationOptions
    } = t0);
    $[2] = t0;
    $[3] = onError;
    $[4] = onSettled;
    $[5] = onSuccess;
    $[6] = otherMutationOptions;
    $[7] = t1;
  } else {
    onError = $[3];
    onSettled = $[4];
    onSuccess = $[5];
    otherMutationOptions = $[6];
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const queryKeysToInvalidate = t2;
  let t3;
  if ($[10] !== otherMutationOptions || $[11] !== path || $[12] !== verb) {
    t3 = t4 => {
      const options = t4 === undefined ? {} : t4;
      return executeRequest(verb, path, {
        ...otherMutationOptions,
        ...options
      } as any) as any;
    };
    $[10] = otherMutationOptions;
    $[11] = path;
    $[12] = verb;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== invalidateQueryKeys || $[15] !== onError || $[16] !== onSettled || $[17] !== onSuccess || $[18] !== path || $[19] !== queryKeysToInvalidate || $[20] !== t3) {
    t4 = {
      mutationFn: t3,
      onSuccess(...t5) {
        const successResponse = t5;
        invalidateQueryKeys(path, queryKeysToInvalidate);
        if (onSuccess) {
          onSuccess(...successResponse);
        }
      },
      onError,
      onSettled
    };
    $[14] = invalidateQueryKeys;
    $[15] = onError;
    $[16] = onSettled;
    $[17] = onSuccess;
    $[18] = path;
    $[19] = queryKeysToInvalidate;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return useMutation(t4);
}